// removed by extract-text-webpack-plugin
module.exports = {"datepicker":"datepicker__1kHXn","active":"active__XZoE2","overlay":"overlay__1Yfh-","container":"container__2VbIV","ranges":"ranges__3n8Ux"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DatePicker/styles.scss
// module id = 2124
// module chunks = 1